export default Object.freeze([
    'steel',
    'copper',
    'galvanizedSteel',
    'other',
]);
